import * as ACTION_TYPES from "./action_type";
import {getUsers as fetchUserAPI} from "../../services/user";

export const getUsers = () => {
    return async (dispatch) => {
        dispatch({type: "GET_USERS"});
        try {
            const response = await fetchUserAPI();
            dispatch({
                type: "GET_USERS_SUCCESS",
                payload: response.data,
            });
        } catch (error) {
            console.error("Failed to fetch users!", error);
        }
    };
}

export const getUser = (user) => {
    return {
        type: ACTION_TYPES.GET_USER,
        payload: user,
    };
}

export const updateUser = (user) => {
    return {
        type: ACTION_TYPES.UPDATE_USER,
        payload: user,
    };
}

export const deleteUser = (user) => {
    return {
        type: ACTION_TYPES.DELETE_USER,
        payload: user,
    };
}

export const disableUser = (user) => {
    return {
        type: ACTION_TYPES.DISABLE_USER,
        payload: user,
    };
}

export const enableUser = (user) => {
    return {
        type: ACTION_TYPES.ENABLE_USER,
        payload: user,
    };
}

export const changePassword = (user) => {
    return {
        type: ACTION_TYPES.CHANGE_PASSWORD,
        payload: user,
    };
}

export const resetPassword = (user) => {
    return {
        type: ACTION_TYPES.RESET_PASSWORD,
        payload: user,
    };
}

export const setErrors = (err, msg) => {
    return {
        type: ACTION_TYPES.SET_ERRORS,
        payload: { err, msg },
    };
}
